import request from './index'

export const userList = listQuery => {
	return request({
		url: '/user/list',
		method: 'post',
		data: {
			command_id: 0,
			entityId: listQuery.entityId,
			pageIndex: listQuery.pageIndex,
			pageSize: listQuery.pageSize,
			params: listQuery.params,
			fuzzySearch: listQuery.fuzzySearch
		}
	})
}

export const resetPW = (userId, password) => {
	return request({
		url: '/user/resetPW',
		method: 'post',
		data: {
			command_id: 47,
			userId: userId,
			password: password
		}
	})
}

export const deleteUser = userId => {
	return request({
		url: '/user/deleteUser',
		method: 'post',
		data: {
			command_id: 48,
			userId: userId
		}
	})
}

export const addUser = newUser => {
	return request({
		url: '/user/addUser',
		method: 'post',
		data: {
			command_id: 50,
			user: newUser
		}
	})
}


export const updateUser = (editedUser, isRestPassword) => {
	return request({
		url: '/user/updateUser',
		method: 'post',
		data: {
			command_id: 50,
			user: editedUser,
			passwordOperation: isRestPassword
		}
	})
}

export const listCarUserByEntity = entityId => {
	return request({
		url: '/user/listCarUser/'+entityId,
		method: 'post',
		data: {
			entityId: entityId
		}
	})
}


// export const listAppUser = listQuery => {
// 	return request({
// 		url: '/user/listAppUser',
// 		method: 'post',
// 		data: {
// 			entityId: listQuery.entityId,
// 			pageIndex: listQuery.pageIndex,
// 			pageSize: listQuery.pageSize,
// 			params: listQuery.params,
// 			fuzzySearch: listQuery.fuzzySearch
// 		}
// 	})
// }

export const wechatUserList = listQuery => {
	return request({
		url: '/user/listWechat',
		method: 'post',
		data: {
			command_id: 0,
			entityId: listQuery.entityId,
			pageIndex: listQuery.pageIndex,
			pageSize: listQuery.pageSize,
			params: listQuery.params,
			fuzzySearch: listQuery.fuzzySearch
		}
	})
}

export const updateWechatUser = (editedUser) => {
	return request({
		url: '/user/updateWechatUser',
		method: 'post',
		data: {
			command_id: 50,
			userWechat: editedUser
		}
	})
}

export const deleteWechatUser = userId => {
	return request({
		url: '/user/deleteWechatUser',
		method: 'post',
		data: {
			command_id: 48,
			userId: userId
		}
	})
}
